import { getChosenCookies } from '@/helpers/getChosenCookies';
import { getTrafficSource } from '@/helpers/getTrafficSource';

declare let fbq: any;

// https://developers.facebook.com/docs/facebook-pixel/advanced/
let FacebookInitializationOnce = false;
export const FacebookService = {
	initialization(pixelId: string, callback?: () => void) {
		if (!FacebookInitializationOnce) {
			FacebookInitializationOnce = true;

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.text = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${pixelId}');
				fbq('track', 'PageView');
				${callback?.()};
    	`;
			document.body.appendChild(script);
		}
	},
	logEvent(name: string, options?: object, settings?: object) {
		if (
			getChosenCookies('marketing') &&
			getTrafficSource().allowFacebook &&
			(window as any).fbq
		) {
			(window as any).fbq('track', name, options, settings);
		}
	},
	remove(pixelId: string) {
		if (FacebookInitializationOnce && (window as any).fbq) {
			// Disable further tracking by setting autoConfig to false
			(window as any).fbq('set', 'autoConfig', false, pixelId.toString());

			// Remove all external Facebook Pixel scripts from DOM
			const fbScripts = document.querySelectorAll(
				'script[src*="connect.facebook.net"]',
			);
			fbScripts.forEach(script => script.remove());

			// Remove inline script if it contains 'connect.facebook.net/en_US/fbevents.js'
			document.querySelectorAll('script').forEach(script => {
				if (
					script.innerHTML.includes('connect.facebook.net/en_US/fbevents.js')
				) {
					script.remove();
				}
			});

			// Remove the fbq function and related global variables
			delete (window as any).fbq;
			// eslint-disable-next-line no-underscore-dangle
			delete (window as any)._fbq;

			console.log('Facebook analytics disabled');
		}
	},
};
